import { HelixApiResponse } from 'api/helix/utils/types';

export function extractDataFromHelixResponse<T>(rawResult: HelixApiResponse<T>): T {
  return rawResult.data;
}
